<template>
  <CheckboxRoot
    v-slot="slotProps"
    data-slot="checkbox"
    v-bind="forwarded"
    :class="
      cn(
        'tw:peer tw:border-(--border-checkbox) tw:bg-card tw:data-[state=checked]:bg-primary tw:data-[state=checked]:text-primary-foreground tw:data-[state=checked]:border-primary tw:focus-visible:border-ring tw:focus-visible:ring-ring/50 tw:aria-invalid:ring-destructive/20 tw:aria-invalid:border-destructive tw:size-[26px] tw:shrink-0 tw:rounded-[8px] tw:border-2 tw:transition-shadow tw:outline-none tw:focus-visible:ring-3 tw:disabled:cursor-not-allowed tw:disabled:opacity-50',
        props.class,
      )
    "
  >
    <CheckboxIndicator
      data-slot="checkbox-indicator"
      class="tw:grid tw:place-content-center tw:text-current tw:transition-none"
    >
      <slot v-bind="slotProps">
        <AppIcon size="meta" name="check" />
      </slot>
    </CheckboxIndicator>
  </CheckboxRoot>
</template>

<script setup>
defineOptions({ name: 'UiCheckbox' });
import AppIcon from '@/shared/components/AppIcon.vue';
import { reactiveOmit } from '@vueuse/core';
import { cn } from '@/shared/utilities/classes';
import { CheckboxIndicator, CheckboxRoot, useForwardPropsEmits } from 'reka-ui';

const props = defineProps({
  defaultValue: { default: undefined, type: null, required: false },
  modelValue: { default: undefined, type: null, required: false },
  disabled: { default: undefined, type: Boolean, required: false },
  value: { default: undefined, type: null, required: false },
  id: { default: undefined, type: String, required: false },
  trueValue: { default: undefined, type: null, required: false },
  falseValue: { default: undefined, type: null, required: false },
  asChild: { default: undefined, type: Boolean, required: false },
  as: { default: undefined, type: null, required: false },
  name: { default: undefined, type: String, required: false },
  required: { default: undefined, type: Boolean, required: false },
  class: {
    default: undefined,
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
const emits = defineEmits(['update:modelValue']);

const delegatedProps = reactiveOmit(props, 'class');

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>
